import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';
import { QuestionIcon } from '@/icons';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid ${COLORS.LIGHT_GRAY};
  background: ${COLORS.WHITE};
  text-align: left;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  text-transform: uppercase;
`;

export const StyledTimeline = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: 1rem;
`;

export const StyledTimelineItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  position: relative;
  padding-bottom: 1rem;

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:last-child)::before {
    content: '';
    position: absolute;
    left: 0.875rem;
    top: 2.25rem;
    bottom: 0;
    width: 1px;
    background: ${COLORS.LIGHT_GRAY};
    z-index: 0;
  }
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  min-width: 1.75rem;
  border-radius: 50%;
  border: 1px solid ${COLORS.LIGHT_GRAY_2};
  background: ${COLORS.WHITE};
  z-index: 1;

  svg {
    width: 0.875rem;
    height: 0.875rem;
  }

  &.is-completed {
    border-color: ${COLORS.GREEN};
    background: ${COLORS.GREEN};
    color: ${COLORS.WHITE};

    svg path {
      fill: ${COLORS.WHITE};
    }
  }

  &.is-current {
    border-color: ${COLORS.YELLOW_PRIMARY};
    background: ${COLORS.YELLOW_PRIMARY};
    color: ${COLORS.BLACK};

    svg circle,
    svg path {
      stroke: ${COLORS.BLACK};
    }
  }

  &.is-cancelled {
    border-color: ${COLORS.RED};
    background: ${COLORS.RED};
    color: ${COLORS.WHITE};

    svg path {
      fill: ${COLORS.WHITE};
    }
  }

  &.is-skipped {
    border-color: ${COLORS.LIGHT_GRAY_2};
    background: ${COLORS.WHITE};
    color: ${COLORS.GRAY_PRIMARY};

    svg path {
      stroke: ${COLORS.GRAY_PRIMARY};
    }
  }

  &.is-future {
    border-color: ${COLORS.LIGHT_GRAY_2};
    background: ${COLORS.WHITE};
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  padding-top: 0.25rem;
`;

export const StyledStatusName = styled.div<{ $muted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  ${pickThemeFontStyles('14', '20', 'SEMI_NORMAL')};
  color: ${({ $muted }) => ($muted ? COLORS.GRAY_PRIMARY : COLORS.BLACK)};
`;

export const StyledCurrentBadge = styled.span`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 0.125rem 0.5rem;
  border-radius: 0.75rem;
  background: ${COLORS.YELLOW_PRIMARY};
  ${pickThemeFontStyles('12', '16', 'SEMI_NORMAL')};
  color: ${COLORS.BLACK};
`;

export const StyledDate = styled.div`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.GRAY_PRIMARY};
`;

export const StyledQuestionIcon = styled(QuestionIcon)`
  cursor: pointer;
`;
